import { IconProps } from "typing";
import { theme } from "../themes";

export const PercentageDiscount = ({
  width = 28,
  height = 28,
  color = theme.colors.secondary["265"],
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
    >
      <g id="percentageDiscount">
        <ellipse
          id="Oval"
          cx="6.28433"
          cy="7.10494"
          rx="0.615385"
          ry="0.761194"
          fill={color}
        />
        <ellipse
          id="Oval_2"
          cx="10.715"
          cy="9.89596"
          rx="0.615385"
          ry="0.761194"
          fill={color}
        />
        <path
          id="Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0468 9.08696L16.2944 9.43878C16.6725 9.97871 16.5119 10.7381 15.9531 11.0586L15.5884 11.2711C15.1903 11.501 14.9761 11.9712 15.0598 12.438L15.1367 12.8665C15.2538 13.5213 14.7921 14.1344 14.153 14.1727L13.7348 14.1971C13.2797 14.2215 12.8916 14.549 12.7711 15.0088L12.6607 15.4303C12.4901 16.0712 11.8209 16.4161 11.2286 16.1618L10.8405 15.9946C10.4189 15.8134 9.93375 15.9319 9.63261 16.2907L9.35824 16.6181C8.93999 17.1232 8.19384 17.1267 7.76556 16.632L7.48784 16.3081C7.18336 15.9528 6.69485 15.8413 6.2766 16.0294L5.89182 16.2001C5.30292 16.4648 4.62704 16.1339 4.4497 15.493L4.33259 15.0749C4.20545 14.6186 3.81062 14.2981 3.35557 14.2772L2.93732 14.2598C2.29824 14.232 1.82646 13.6258 1.93353 12.971L2.0038 12.5425C2.08076 12.0722 1.85992 11.6055 1.4584 11.3825L1.09035 11.177C0.524879 10.86 0.354234 10.1041 0.722291 9.5607L0.963201 9.20539C1.22753 8.81525 1.22084 8.29622 0.953163 7.91304L0.705561 7.56122C0.327467 7.02477 0.488073 6.26539 1.04685 5.94143L1.41156 5.72894C1.80973 5.49904 2.02387 5.02878 1.94022 4.562L1.86327 4.13354C1.74616 3.47865 2.2079 2.86557 2.84698 2.82726L3.26523 2.80287C3.72028 2.77849 4.10841 2.45105 4.22887 1.99124L4.33929 1.56974C4.50993 0.928794 5.17912 0.583936 5.77136 0.838226L6.15949 1.00543C6.58109 1.18657 7.06625 1.06813 7.36739 0.709339L7.64176 0.381898C8.06335 -0.123197 8.8095 -0.126681 9.23444 0.367964L9.51216 0.691922C9.81664 1.04723 10.3052 1.1587 10.7234 0.970595L11.1082 0.799908C11.6971 0.535168 12.373 0.866093 12.5503 1.50704L12.6674 1.92505C12.7946 2.38138 13.1894 2.70185 13.6444 2.72275L14.0627 2.74017C14.7018 2.76804 15.1735 3.37415 15.0665 4.02904L14.9962 4.4575C14.9192 4.92776 15.1401 5.39453 15.5416 5.61747L15.9097 5.82299C16.4751 6.13999 16.6458 6.89589 16.2777 7.4393L16.0368 7.79461C15.7725 8.18475 15.7792 8.70378 16.0468 9.08696ZM6.32688 5.3418C5.41678 5.3418 4.68066 6.10815 4.68066 7.05564C4.68066 7.99964 5.41678 8.76948 6.32688 8.76948C7.23699 8.76948 7.9731 8.00313 7.9731 7.05564C7.9731 6.10815 7.23699 5.3418 6.32688 5.3418ZM6.6443 11.4769C6.50377 11.6545 6.24948 11.6789 6.07883 11.5326C5.90819 11.3863 5.88477 11.1215 6.0253 10.9439L10.3449 5.52718C10.4855 5.34953 10.7398 5.32514 10.9104 5.47145C11.0811 5.61775 11.1045 5.88249 10.9639 6.06014L6.6443 11.4769ZM9.02051 9.9404C9.02051 10.8879 9.75662 11.6542 10.6667 11.6542C11.5768 11.6542 12.3129 10.8879 12.3129 9.9404C12.3129 8.99291 11.5768 8.22656 10.6667 8.22656C9.75662 8.22656 9.02051 8.99291 9.02051 9.9404Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
